module.exports = __webpack_public_path__ + "static/img/Switch-Laptop.139dc38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Switch-Laptop.png
// module id = zzbw
// module chunks = 1